const KNOWN_ERRORS = [
    'RIVHIT_INVALID_ZIP', 'RIVHIT_PASSWORD_REQUIRED', 'RIVHIT_WRONG_PASSWORD', 'RIVHIT_NOT_A_BACKUP',
    'RIVHIT_UNREADABLE', 'RIVHIT_DATABASE_REQUIRED', 'RIVHIT_CLIENT_NOT_FOUND', 'RIVHIT_FORMAT_NOT_SUPPORTED',
];

/** The message of a failed backup request: the server's key translated, its own message for other bad requests. */
export const rivhitBackupErrorMessage = (err, t) => {
    const key = String(err?.message || '').trim().replace(/^"|"$/g, '');
    if (KNOWN_ERRORS.includes(key)) return t(`rivhitBackup.errors.${key}`);
    return err?.status === 400 && key ? key : t('rivhitBackup.errors.generic');
};

/** Whether the zip needs (another) password – the user can fix it and read the file again. */
export const isPasswordError = (err) => ['RIVHIT_PASSWORD_REQUIRED', 'RIVHIT_WRONG_PASSWORD']
    .includes(String(err?.message || '').trim().replace(/^"|"$/g, ''));
